import CityPageTemplate from "../city-template/CityPageTemplate";
import { detroitConfig } from "./data";

export default function DetroitPage() {
  return <CityPageTemplate config={detroitConfig} />;
}